module.exports = __webpack_public_path__ + "assets/8901d097bcc2e200d0900d56378f7e53.mp3";